import React from "react";

export default function CentrosSummary({ resumen = [], onQuickFilter, activeKey }) {
  return (
    <div className="management-card centros-summary-card mb-4">
      <div className="centros-summary-grid">
        {resumen.map((stat) => (
          <button
            key={stat.key || stat.label}
            type="button"
            className={`management-stat-card centros-stat-card ${stat.accent ?? ""} ${
              activeKey === stat.key ? "active" : ""
            }`}
            onClick={() => onQuickFilter?.(stat.key)}
          >
            <div className="management-stat-icon">
              <i className={stat.icon} />
            </div>
            <div>
              <p className="management-stat-label mb-1">{stat.label}</p>
              <p className="management-stat-value mb-0">{stat.value}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
